import { render, staticRenderFns } from "./PayByCard.vue?vue&type=template&id=d0045b74"
import script from "./PayByCard.vue?vue&type=script&lang=js"
export * from "./PayByCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports